var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticClass: "table" }, [
      _c(
        "tbody",
        _vm._l(_vm.quote, function(value, key) {
          return key !== "uses_franking_machine" && _vm.index(key) < 57
            ? _c("tr", [
                _c("td", [_c("b", [_vm._v("I" + _vm._s(_vm.index(key)))])]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(key))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(value))])
              ])
            : _vm._e()
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ab18862", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab18862","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Debug/QuoteInfo/Keys.vue
// module id = null
// module chunks = 